// extracted by mini-css-extract-plugin
export default {"card":"styles_card__RBDNd","item_text":"styles_item_text__kW0Qg","item_icon":"styles_item_icon__4DWMR","weight":"styles_weight__WvmTF","item_code":"styles_item_code__QJQ8p"};